import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "relative flex group"
}
const _hoisted_2 = { class: "underline cursor-not-allowed text-blue" }
const _hoisted_3 = { class: "absolute px-1 m-1 mx-auto text-sm text-gray-100 transition-opacity bg-gray-800 rounded-md opacity-0 cursor-not-allowed -translate-x-1/3 -translate-y-1/3 w-fit bottom-4 group-hover:opacity-100" }




export default /*#__PURE__*/_defineComponent({
  __name: 'ClubStudentRouterButton',
  props: {
  to: {
    type: String,
    required: true,
  },
  student: {
    type: Object as () => { id: string; survey_permission: boolean },
    required: true,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (__props.student.survey_permission)
    ? (_openBlock(), _createBlock(_component_router_link, {
        key: 0,
        to: __props.to,
        class: "underline text-blue"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("view")), 1)
        ]),
        _: 1
      }, 8, ["to"]))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t("view")), 1),
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t("parent-consent-button")), 1)
      ]))
}
}

})